<template>
  <div class="block py-24 sm:py-48" :class="{'w-full': inGrid}">
    <div class="container video-block mx-auto lg:flex xxl:px-24">
      <div
        class="video w-full bg-cover bg-center relative lg:h-auto lg:w-1/2"
        :class="
          component.videoType === 'embedded' ? 'h-auto' : 'h-320 sm:h-410'
        "
        :style="`background-image: url(${component.previewImage})`"
      >
        <nuxt-img
          v-if="component.previewImage && component.videoType === 'image'"
          :src="component.previewImage"
          preset="standard"
          sizes="mob375:100vw mob390:100vw mob414:100vw desk:655px"
          class="object-center object-cover absolute top-0 left-0 h-full w-full"
          alt=""
        />
        <video
          v-if="component.videoType === 'video'"
          class="absolute top-0 left-0 w-full h-full object-cover object-center"
          autoplay
          muted
          loop
          playsinline
          :poster="component.previewImage"
        >
          <source :src="component.video.url" type="video/mp4">
        </video>
        <div
          v-if="component.videoType === 'embedded'"
          id="video-player"
          class="absolute top-0 left-0 w-full h-full bg-black"
        >
          <transition name="fade">
            <div
              class="video__overlay absolute z-10 w-full h-full top-0 left-0 pointer-events-none"
            >
              <div
                class="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              >
                <div
                  class="rounded-full h-48 w-48 border border-white flex items-center justify-center mx-auto"
                >
                  <fa
                    :icon="['fas', 'play']"
                    class="text-white block transform translate-x-2"
                  />
                </div>
                <div
                  v-if="component.previewText"
                  class="text-white mt-24 mx-auto uppercase text-sm tracking-wide wp-content"
                  v-html="component.previewText"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div
        class="video-block__content w-full lg:w-1/2 py-40 md:p-56 lg:py-70 lg:px-128 xl:py-96"
        :class="{
          'lg:order-first': component.backgroundPosition === 'right',
        }"
      >
        <div class="wysiwyg mx-auto">
          <h3>{{ component.title }}</h3>
          <div v-html="component.content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    inGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      videoPlay: true,
      pointerEvents: true,
    };
  },
  mounted() {
    if (this.component.videoType === 'embedded') {
      this.playVideo();
    }
  },
  methods: {
    playVideo() {
      const component = this.component as ComponentBlock;

      if (
        component.videoType === 'embedded' &&
        document.querySelector('#video-player')
      ) {
        const videoEmbeddedSplit = component.videoEmbedded.split('"');
        let index = 0;

        for (const slice of videoEmbeddedSplit) {
          if (slice.includes('youtube')) {
            const videoId = component.videoEmbedded
              .split('embed/')[1]
              .substring(0, 11);
            videoEmbeddedSplit[index] =
              slice +
              '&autoplay=1&controls=0&mute=1&loop=1&playlist=' +
              videoId;
          } else if (slice.includes('player.vimeo')) {
            videoEmbeddedSplit[index] =
              slice + '&autoplay=1&controls=0&mute=1&loop=1';
          }
          index++;
        }

        const videoEmbeddedDOM = videoEmbeddedSplit.join('"');
        document.querySelector('#video-player')!.innerHTML = videoEmbeddedDOM;
      }
    },
  },
});
</script>

<style>
.video-block {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

.video {
  &--yt {
    @apply h-0 overflow-hidden;
    padding-top: 56.25%;

    @screen lg {
      @apply h-full pt-0;
    }
  }

  iframe {
    @apply absolute h-full top-0 left-0 w-full;
  }

  #video-player {
    @apply relative h-0;
    padding-bottom: 56.25%;

    @screen lg {
      @apply relative;
    }
  }
}
</style>
